import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EnvironmentModule } from '@campus/environment';
import { SvgModule } from '@campus/svg';
import { dcrIconService } from '@diekeure/dcr-components';
import { CookiesContentComponent } from './cookies-content/cookies-content.component';
import { COOKIE_INPUT_TOKEN, CookieInputService } from './cookies-content/services/cookie-input';
import { COOKIES_SERVICE_TOKEN, CookiesService } from './cookies-content/services/cookies';

import { icons } from './icons';

dcrIconService.registerIcons(icons);

@NgModule({
  imports: [
    CommonModule,
    EnvironmentModule,
    BrowserModule,
    MatSlideToggleModule,
    MatButtonModule,
    BrowserAnimationsModule,
    SvgModule,
  ],
  declarations: [CookiesContentComponent],
  exports: [CookiesContentComponent],
  providers: [
    {
      provide: COOKIES_SERVICE_TOKEN,
      useClass: CookiesService,
    },
    {
      provide: COOKIE_INPUT_TOKEN,
      useClass: CookieInputService,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CookiesModule {}
